import React, { useMemo } from 'react';
import format from 'date-fns/format';
import { toast } from 'components/Shared/Toast'
import { useTranslation } from 'react-i18next';

import { parseDate } from 'utils';

export function Participant({ userForm }) {

    const { t } = useTranslation();

    return (
        <div className="p-3 overflow-y-auto">
            <h4>{t('Participante')}</h4>
            <PropertyItem label={t('contracts.properties.name')} value={`${userForm.participant?.name} ${userForm.participant?.obligation === 'individual' && userForm.participant?.last_name ? userForm.participant?.last_name : ''}`} />
            <PropertyItem label={t('Estatus')} value={userForm.status === 'completed' ? 'Completado' : userForm?.status === 'signed' ? 'Concluido' : 'Pendiente'} />
            { userForm.participant?.obligation === 'legal' && <PropertyItem label={t('Representante Legal')} value={userForm.participant?.representative} /> }
            <PropertyItem label={t('Correo')} value={userForm.participant?.email} />
            <PropertyItem label={t('Celular')} value={userForm.participant?.phone} />
        </div>
    )
};

export function PropertyItem({ label, value, url, required }) {
    return (
        <div className="properties-listing mt-2">
            <label id="name" className="font-weight-bold">{label} {required ? <span className="text-primary">*</span> : ''}</label>{' '}
            <div>{url ? <a href={url} target="_blank" rel="noreferrer">{value}</a>: value}</div>
        </div>
    )
}


